__turbopack_context__.v({
  "brandLogoWrapper": "_2-vS9q_brandLogoWrapper",
  "brandName": "_2-vS9q_brandName",
  "brandWrapper": "_2-vS9q_brandWrapper",
  "breadcrumbsWrapper": "_2-vS9q_breadcrumbsWrapper",
  "header": "_2-vS9q_header",
  "loaderWrapper": "_2-vS9q_loaderWrapper",
  "onlyDesktopContent": "_2-vS9q_onlyDesktopContent",
  "onlyWebContent": "_2-vS9q_onlyWebContent",
  "sortingInputWrapper": "_2-vS9q_sortingInputWrapper",
  "sortingLabel": "_2-vS9q_sortingLabel",
  "title": "_2-vS9q_title",
  "titleBanner": "_2-vS9q_titleBanner",
  "titleBannerHeading": "_2-vS9q_titleBannerHeading",
  "wrapper": "_2-vS9q_wrapper",
});
